<div class="col-xl">
    <form #myForm="ngForm" [formGroup]="serviceForm" id="formService" (ngSubmit)="openModalConfirm()">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Datos de la solicitud</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3 p-3">
                    <div class="col d-flex align-items-center info p-3">
                        <span class="me-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <g clip-path="url(#clip0_265_2694)">
                                    <path d="M18.3337 10C18.3337 5.39762 14.6027 1.66666 10.0003 1.66666C5.39795 1.66666 1.66699 5.39762 1.66699 10C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 10Z" stroke="#019DDA" stroke-width="1.5"/>
                                    <path d="M10.202 14.1667V9.99999C10.202 9.60715 10.202 9.41073 10.0799 9.2887C9.95791 9.16666 9.76149 9.16666 9.36865 9.16666" stroke="#019DDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.99349 6.66666H10.001" stroke="#019DDA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_265_2694">
                                    <rect width="20" height="20" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </span> Evita códigos como “7XQ3+JWR” en las direcciones. Si no tienes la dirección exacta, usa una cercana con calle, número y código postal.
                    </div>
                </div>
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Cliente*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="client"
                                    [(ngModel)]="formModelData.client"
                                    [ngClass]="(fc['client']?.errors && !fc['client']?.pristine && isSubmitted) ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataClient">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-6 col-md-4 col-xs-12">
                            <div class="row">
                                <div class="col-lg-12">
                                    <label class="form-label" for="basic-default-company">Origen*</label>
                                    <div class="input-group input-group-merge">
                                        <select *ngIf="clientSelected.origin_address.length == 0 && !changed_label_origin" class="form-select"
                                            formControlName="origin" [(ngModel)]="formModelData.origin"
                                            [ngClass]="(fc['origin']?.errors && !fc['origin']?.pristine && isSubmitted) ? 'is-invalid' : ''">
                                            <option value="" selected>Seleccione un opción</option>

                                        </select>

                                        <select *ngIf="clientSelected.origin_address.length && !changed_label_origin" class="form-select"
                                            formControlName="origin" [(ngModel)]="formModelData.origin"
                                            [ngClass]="(fc['origin']?.errors && !fc['origin']?.pristine && isSubmitted) ? 'is-invalid' : ''">
                                            <option value="" selected>Seleccione un opción</option>
                                            <option
                                                [value]="item.street+' '+item.number + ' ' + item.cologne + ', '+ item.postal_code + ' ' + item.stated"
                                                *ngFor="let item of clientSelected.origin_address">{{item.street}}
                                                {{item.number}} {{item.cologne}}, {{item.postal_code}} {{item.stated}}
                                            </option>

                                        </select>
                                        <input class="form-control" id="origin_address" type="text" *ngIf="changed_label_origin" formControlName="origin" [(ngModel)]="formModelData.origin" type="text"
                                            (input)="onMainAddressInputChanged('origin')"
                                            [ngClass]="fc['origin']?.errors && !fc['origin']?.pristine && isSubmitted ? 'is-invalid' : ''">

                                        <div class="invalid-feedback"
                                            *ngIf="fc['origin']?.errors && !fc['origin']?.pristine && isSubmitted">
                                            El campo origen es obligatorio
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-2">
                                    <br>
                                    <button type="button" class="btn btn-info" (click)="autocomple_origin() ">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-repeat" viewBox="0 0 16 16">
                                            <path d="M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z"/>
                                        </svg>
                                    </button>
                                </div> -->
                            </div>


                        </div>
                        <div class="col-lg-6 col-md-4 col-xs-12">
                            <div class="row">
                                <div class="col-lg-12">
                                    <label class="form-label" for="basic-default-company">Destino*</label>
                                    <div class="input-group input-group-merge">
                                        <select *ngIf="clientSelected.destination_address.length == 0 && !changed_label_destination" class="form-select"
                                            formControlName="destination" [(ngModel)]="formModelData.destination"
                                            [ngClass]="fc['destination']?.errors  && !fc['destination']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                            <option value="" selected>Seleccione un opción</option>
        
                                        </select>
                                        <select *ngIf="clientSelected.destination_address.length > 0 && !changed_label_destination" class="form-select"
                                            formControlName="destination" [(ngModel)]="formModelData.destination"
                                            [ngClass]="fc['destination']?.errors  && !fc['destination']?.pristine && isSubmitted ? 'is-invalid' : ''">
        
                                            <option value="" selected>Seleccione un opción</option>
                                            <option
                                                [value]="item.street+' '+item.number + ' ' + item.cologne + ', '+ item.postal_code + ' ' + item.stated"
                                                *ngFor="let item of clientSelected.destination_address">{{item.street}}
                                                {{item.number}} {{item.cologne}}, {{item.postal_code}} {{item.stated}}</option>
        
                                        </select>

                                        <input class="form-control" id="destination_address" formControlName="destination" [(ngModel)]="formModelData.destination" type="text" *ngIf="changed_label_destination" 
                                            (input)="onMainAddressInputChanged('destination')"
                                            [ngClass]="fc['destination'].errors  && !fc['destination'].pristine && isSubmitted ? 'is-invalid' : '' ">
                                        <div class="invalid-feedback"
                                            *ngIf="fc['destination'].errors  && !fc['destination'].pristine && isSubmitted">
                                            El campo destino es obligatorio
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-2">
                                    <br>
                                    <button type="button" class="btn btn-info" (click)="autocomple_destination()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-repeat" viewBox="0 0 16 16">
                                            <path d="M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z"/>
                                        </svg>
                                    </button>
                                </div> -->
                            </div>
                            
                        </div>
                        <div class="col-lg-12 col-md-12 col-xs-12 mt-2">
                            <div class="d-flex align-items-center justify-content-start" style="color: #049DE3; font-size: 14px; line-height: 1;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" style="flex-shrink: 0;">
                                    <g clip-path="url(#clip0_106_7672)">
                                        <path d="M16.826 8.99996C16.826 4.67773 13.3221 1.17388 8.99992 1.17388C4.67769 1.17388 1.17383 4.67773 1.17383 8.99996C1.17383 13.3222 4.67769 16.826 8.99992 16.826C13.3221 16.826 16.826 13.3222 16.826 8.99996Z" stroke="#049DE3" stroke-width="1.5"/>
                                        <path d="M9.18935 12.9129V8.99989C9.18935 8.63097 9.18935 8.44651 9.07474 8.3319C8.96013 8.21729 8.77566 8.21729 8.40674 8.21729" stroke="#049DE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.9935 5.86951H9.00053" stroke="#049DE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_106_7672">
                                        <rect width="18" height="18" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="ms-2" style="vertical-align: middle;">Es importante que la dirección destino cuente con un código postal</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngFor="let item of formModelData.address; let i = index">
                        <div class="col-lg-6 col-md-6 col-xs-12">
                            <div class="row">
                                <div class="col-lg-10">
                                    <label class="form-label" for="basic-default-company">Origen*</label>
                                    <div class="input-group input-group-merge">
                                        <select *ngIf="clientSelected.origin_address.length == 0 && !item.input_origin" class="form-select" name="origin" [(ngModel)]="item.origin" [ngModelOptions]="{standalone: true}">
                                            <option value="" selected>Seleccione un opción</option>
                                        </select>

                                        <select *ngIf="clientSelected.origin_address.length && !item.input_origin" class="form-select" name="origin" [(ngModel)]="item.origin" [ngModelOptions]="{standalone: true}">
                                            <option value="" selected>Seleccione un opción</option>
                                            <option
                                                [value]="item.street+' '+item.number + ' ' + item.cologne + ', '+ item.postal_code + ' ' + item.stated"
                                                *ngFor="let item of clientSelected.origin_address">{{item.street}}
                                                {{item.number}} {{item.cologne}}, {{item.postal_code}} {{item.stated}}
                                            </option>

                                        </select>
                                        <input class="form-control" id="origin_address_{{i}}" type="text" *ngIf="item.input_origin" name="origin{{i}}" [(ngModel)]="item.origin" type="text" [ngModelOptions]="{standalone: true}"
                                            (input)="onMultiAddressInputChanged(item, 'origin')">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <br>
                                    <button type="button" class="btn btn-info" (click)="autocomple_origin_mult(i, item)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-repeat" viewBox="0 0 16 16">
                                            <path d="M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-xs-12">
                            <div class="row">
                                <div class="col-lg-10">
                                    <label class="form-label" for="basic-default-company">Destino*</label>
                                    <div class="input-group input-group-merge">
                                        <select *ngIf="clientSelected.destination_address.length == 0 && !item.input_destination" class="form-select"
                                            name="destination{{i}}" [(ngModel)]="item.destination" [ngModelOptions]="{standalone: true}">
                                            <option value="" selected>Seleccione un opción</option>
        
                                        </select>
                                        <select *ngIf="clientSelected.destination_address.length > 0 && !item.input_destination" class="form-select"
                                            name="destination" [(ngModel)]="item.destination" [ngModelOptions]="{standalone: true}">
        
                                            <option value="" selected>Seleccione un opción</option>
                                            <option
                                                [value]="item.street+' '+item.number + ' ' + item.cologne + ', '+ item.postal_code + ' ' + item.stated"
                                                *ngFor="let item of clientSelected.destination_address">{{item.street}}
                                                {{item.number}} {{item.cologne}}, {{item.postal_code}} {{item.stated}}</option>
        
                                        </select>

                                        <input class="form-control" id="destination_address_{{i}}" name="destination" [(ngModel)]="item.destination" type="text" *ngIf="item.input_destination" [ngModelOptions]="{standalone: true}"
                                            (input)="onMultiAddressInputChanged(item, 'destination')">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <br>
                                    <button type="button" class="btn btn-info" (click)="autocomple_destination_mult(i, item)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-repeat" viewBox="0 0 16 16">
                                            <path d="M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                        <label class="form-label" for="basic-default-company" style="position: absolute; top: 49%; right: 1%; width: 45px;"> 
                            <span style="float: right; cursor: pointer;" (click)="deleteAddress(i)"><i class="ti ti-trash"></i></span>
                        </label>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-4 col-md-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Unidad*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" formControlName="unit" [(ngModel)]="formModelData.unit"
                                    (change)="changedValidUnified($event)"
                                    [ngClass]="fc['unit']?.errors  && !fc['unit']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataUnit">{{item.unit}}</option>
                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['unit']?.errors  && !fc['unit']?.pristine && isSubmitted">
                                    *ngIf="fc['unit']?.errors  && !fc['unit'].pristine && isSubmitted">
                                    El campo unidad es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 col-md-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Operador*</label>
                            <div class="input-group input-group-merge">
                                <select *ngIf="!isUnified" class="form-select" formControlName="driver" [(ngModel)]="formModelData.driver"
                                    [ngClass]="fc['driver']?.errors  && !fc['driver']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    (change)="changedDriver($event)">

                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataDriver">{{item.name}}
                                        {{item.last_name}}</option>
                                </select>
                                <p *ngIf="isUnified">{{dataValidUnified.driver}}</p>
                                <div class="invalid-feedback"
                                    *ngIf="fc['driver']?.errors  && !fc['driver']?.pristine && isSubmitted">
                                    El campo operador es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Auxiliar*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" formControlName="assistant"
                                    [(ngModel)]="formModelData.assistant"
                                    *ngIf="!isUnified"
                                    [ngClass]="fc['assistant']?.errors  && !fc['assistant']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataAssistant">{{item.name}} {{item.last_name}}</option>
                                </select>
                                <p *ngIf="isUnified">{{dataValidUnified.assistant}}</p>
                                <div class="invalid-feedback"
                                    *ngIf="fc['assistant']?.errors  && !fc['assistant']?.pristine && isSubmitted">
                                    El campo auxiliar es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngFor="let item of formModelData.assistants; let i = index" class="col-lg-4 col-md-4 col-xs-12 mt-3">
                            <label class="form-label" for="basic-default-company" style="display: block;">Auxiliar* 
                                <span style="float: right; cursor: pointer;" (click)="deleteAssitant(i)"><i class="ti ti-x"></i></span></label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" name="assistant" [(ngModel)]="item.assistant_id" [ngModelOptions]="{standalone: true}">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataAssistant">{{item.name}} {{item.last_name}}</option>

                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="fc['assistant']?.errors  && !fc['assistant']?.pristine && isSubmitted">
                                    El campo auxiliar es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-xs-12 mt-3">
                            <label *ngIf="!isUnified" class="form-label" for="basic-default-company"> Agregar otro Auxiliar</label>
                            <a *ngIf="isUnified" style="margin-top: 5px; display: block; cursor: pointer; color: #00cfe8;" ><i class="ti ti-info-circle"></i>&ensp; Unidad Unificada</a>
                            <br>
                            
                            <a (click)="addAuxAssistant()" *ngIf="!isUnified" style="margin-top: 5px; display: block; cursor: pointer; color: #00cfe8;" ><i class="ti ti-plus"></i> Agregar</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-xs-12 mt-3" *ngIf="formModelData.requires_trailer">
                            <label class="form-label" for="basic-default-company">Tipo de remolque*</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" formControlName="trailer_id" [(ngModel)]="formModelData.trailer_id"
                                    [ngClass]="isSubmitted && (!formModelData.trailer_id || formModelData.trailer_id === '') ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item.id" *ngFor="let item of dataTrailers">{{item.trailer}}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="isSubmitted && (!formModelData.trailer_id || formModelData.trailer_id === '')">
                                    El campo remolque es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-header d-flex justify-content-between align-items-center pb-1 pt-0">
                <h5 class="mb-0">Fecha del servicio - Carga</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row mb-3">
                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Hora Salida Patio*</label>
                            <div class="input-group input-group-merge">

                                <input type="time" class="form-control"
                                    [ngClass]="fc['departure_time']?.errors  && !fc['departure_time']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="departure_time" [(ngModel)]="formModelData.departure_time" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['departure_time']?.errors  && !fc['departure_time']?.pristine && isSubmitted">
                                    El campo hora salida patio es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Fecha Salida Patio*</label>
                            <div class="input-group input-group-merge">

                                <input type="date" class="form-control"
                                    [ngClass]="fc['departure_date']?.errors  && !fc['departure_date']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="departure_date" [(ngModel)]="formModelData.departure_date" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['departure_date']?.errors  && !fc['departure_date']?.pristine && isSubmitted">
                                    El campo fecha salida patio es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col"></div>
                    </div>
                    <div class="row">
                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Hora Carga*</label>
                            <div class="input-group input-group-merge">

                                <input type="time" class="form-control"
                                    [ngClass]="fc['charging_hour']?.errors  && !fc['charging_hour']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="charging_hour" [(ngModel)]="formModelData.charging_hour" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['charging_hour']?.errors  && !fc['charging_hour']?.pristine && isSubmitted">
                                    El campo hora carga es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Fecha Carga*</label>
                            <div class="input-group input-group-merge">

                                <input type="date" class="form-control"
                                    [ngClass]="fc['upload_date']?.errors  && !fc['upload_date']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="upload_date" [(ngModel)]="formModelData.upload_date" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['upload_date']?.errors  && !fc['upload_date']?.pristine && isSubmitted">
                                    El campo fecha carga es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col col-xs-12">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Fecha del servicio - Descarga</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Hora Descarga*</label>
                            <div class="input-group input-group-merge">

                                <input type="time" class="form-control"
                                    [ngClass]="fc['download_time']?.errors  && !fc['download_time']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="download_time" [(ngModel)]="formModelData.download_time" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['download_time']?.errors  && !fc['download_time']?.pristine && isSubmitted">
                                    El campo hora descarga es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col col-xs-12">
                            <label class="form-label" for="basic-default-company">Fecha Descarga*</label>
                            <div class="input-group input-group-merge">

                                <input type="date" class="form-control"
                                    [ngClass]="fc['download_date']?.errors  && !fc['download_date']?.pristine && isSubmitted ? 'is-invalid' : ''"
                                    formControlName="download_date" [(ngModel)]="formModelData.download_date" />

                                <div class="invalid-feedback"
                                    *ngIf="fc['download_date']?.errors  && !fc['download_date']?.pristine && isSubmitted">
                                    El campo fecha descarga es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col col-xs-12">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Equipo de seguiridad</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row mb-3">
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Bandas*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="bands" [(ngModel)]="formModelData.bands"
                                    [ngClass]="fc['bands']?.errors  && !fc['bands']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['bands']?.errors  && !fc['bands']?.pristine && isSubmitted">
                                    El campo bandas es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Patines*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="roller_skates"
                                    [(ngModel)]="formModelData.roller_skates"
                                    [ngClass]="fc['roller_skates']?.errors  && !fc['roller_skates']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['roller_skates']?.errors  && !fc['roller_skates']?.pristine && isSubmitted">
                                    El campo patines es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Playos*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="beach" [(ngModel)]="formModelData.beach"
                                    [ngClass]="fc['beach']?.errors  && !fc['beach']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['beach']?.errors  && !fc['beach']?.pristine && isSubmitted">
                                    El campo playos es obligatorio
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Diablos*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="devils" [(ngModel)]="formModelData.devils"
                                    [ngClass]="fc['devils']?.errors  && !fc['devils']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['devils']?.errors  && !fc['devils']?.pristine && isSubmitted">
                                    El campo diablos es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Colchonetas*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="mats" [(ngModel)]="formModelData.mats"
                                    [ngClass]="fc['mats']?.errors  && !fc['mats']?.pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['mats']?.errors  && !fc['mats']?.pristine && isSubmitted">
                                    El campo colchonetas es obligatorio
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Cartones*</label>
                            <div class="input-group input-group-merge">

                                <select class="form-select" formControlName="cartons"
                                    [(ngModel)]="formModelData.cartons"
                                    [ngClass]="fc['cartons']?.errors  && !fc['cartons'].pristine && isSubmitted ? 'is-invalid' : ''">
                                    <option value="" selected>Seleccione un opción</option>
                                    <option [value]="item" *ngFor="let item of safety_equipment">{{item}}</option>

                                </select>

                                <div class="invalid-feedback"
                                    *ngIf="fc['cartons']?.errors  && !fc['cartons']?.pristine && isSubmitted">
                                    El campo cartones es obligatorio
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Notas</h5>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <div class="row">
                        <div class="col-lg-12 col-lg-12 col-xs-12">
                            <div class="input-group input-group-merge">
                                <textarea class="form-control" formControlName="observation" [(ngModel)]="formModelData.observation"
                                    [ngClass]="fc['observation'].errors  && !fc['observation'].pristine && isSubmitted ? 'is-invalid' : ''">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body text-center">
                <a role="button" class="btn btn-outline-primary me-sm-3 me-1" [routerLink]="['/service/list']">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none">
                        <path d="M14.75 0.75L0.75 14.75M0.75 0.75L14.75 14.75" stroke="#019DDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> &nbsp;Cancelar
                </a>
                <button type="submit" class="btn btn-primary me-sm-3 me-1" style="background-color: #049DE3 !important;">Actualizar servicio</button>
            </div>
        </div>
    </form>
</div>

<div class="modal fade" id="modalValidUnified" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-md modal-simple modal-refer-and-earn">
        <div class="modal-content p-1 p-md-1">
            <div class="modal-header d-block text-center">
                <h5 class="modal-title text-center">Unificar unidad</h5>
            </div>
            <div class="modal-body pb-1">
                <div class="text-center">
                    <p>
                        La unidad seleccionada se encuentra asignada a otro servicio solicitado<br>
                        <b>¿desea unificar esta unidad al servicio en proceso de creación o desea crear un nuevo servicio para esta unidad?</b>
                    </p>
                </div>
            </div>
            <div class="modal-footer d-block">
                <div class="text-center">
                    <button type="button" class="btn btn-outline-primary m-1" (click)="clickModalValidUnified(false)">Nuevo servicio</button>
                    <button type="button" class="btn btn-primary m-1" style="background-color: #049DE3 !important;" (click)="clickModalValidUnified(true)">Unificar unidad</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modalConfirm" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-md modal-simple modal-refer-and-earn">
        <div class="modal-content p-1 p-md-1">
            <div class="modal-header d-block text-center">
                <h5 class="modal-title text-center">¡Cuidado! Estás a punto de actualizar 
                    <br>los datos de este servicio.</h5>
            </div>
            <div class="modal-body pb-1">
                <div class="text-center">
                    <p>
                        Este cambio es irreversible. ¿Estás seguro de que deseas continuar?
                    </p>
                </div>
            </div>
            <div class="modal-footer d-block">
                <div class="text-center">
                    <button type="button" class="btn btn-outline-primary m-1" data-bs-dismiss="modal" aria-label="Close">Cancelar</button>
                    <button type="button" class="btn btn-primary m-1" style="background-color: #049DE3 !important;" (click)="addService()">Actualizar</button>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="modalStatus" tabindex="1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-simple modal-refer-and-earn">
        <div class="modal-content p-1 p-md-1">
            <div class="modal-header">
                <h4 class="modal-title text-center w-100">¡Cuidado! Estás a punto de cambiar 
                    <br>la unidad de este servicio.</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <div class="text-center mb-4">
                    <h6 class="mb-2">Este cambio es irreversible. ¿Estás seguro de que deseas continuar?</h6>
                </div>
            </div>
            <div class="modal-footer d-block m-0 p-0">
                <div class="row m-0 p-0">
                    <div class="col-lg-6 m-0">
                        <button type="button" class="btn btn-outline-primary m-1 w-100" data-bs-dismiss="modal"
                            aria-label="Close">Cancelar</button>
                    </div>
                    <div class="col-lg-6 m-0">
                        <button type="button" class="btn btn-primary m-1 w-100" (click)="addService()">Cambiar unidad</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-service-expense-group-modal
    *ngIf="showGroupModal"
    [services]="eligibleGroupServices"
    (servicesSelected)="onGroupServicesSelected($event)"
    (modalClosed)="onGroupModalClosed()">
</app-service-expense-group-modal>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">{{text_loading}}</p>
</ngx-spinner>
